import * as React from 'react';
import { Heading5 } from '@flightstats/airframe-react';

type FormResponseErrorProps = {
  message: string;
};

export const FormResponseError: React.FC<FormResponseErrorProps> = ({ message }) => (
    <Heading5 textAlign="center" color="feedback.error">
      {message}
    </Heading5>
);